import React                  from 'react';
import colors                 from '../utils/colors'
import { makeStyles }         from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        width:          60,
        height:         60,
        position:       'fixed',
        top:            20,
        right:          95,
        fontSize:       24,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        borderRadius:   '0.5em',
        border:         `1px solid ${ colors.blue }`,
        color:           colors.blue,
        cursor:         'pointer'
    }
}))

type NavButtonProps = {
    onClick: () => void
}

const NavButton: React.FC<NavButtonProps> = ({ onClick }) => {

  const classes = useStyles();

  return (
     <div 
        className = { classes.root }
        onClick   = { onClick }
     >
        ?
     </div>
  );
}



export default NavButton;








